import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationChartComponent } from '../../../../core/layout/components/organization-chart/organization-chart.component';
import { AdoptionStageComponent } from '../../../../core/layout/components/adoption-stage/adoption-stage.component';
import { PrepareService } from './services/prepare.service';
import { IContext } from './model/prepare.interface';
import { IOrganizationNode } from '../../../../core/layout/components/organization-chart/models/organization-chart.types';
import { Router, ActivatedRoute } from '@angular/router';
import { TabsService } from '../../../../core/layout/components/tabs/services/tabs.service';
import { LoadingComponent } from '../../../../core/layout/components/loading/loading.component';
import { ToolbarComponent } from '../../../../core/layout/components/toolbar/toolbar.component';

@Component({
  selector: 'app-prepare',
  standalone: true,
  imports: [
    CommonModule,
    OrganizationChartComponent,
    AdoptionStageComponent,
    LoadingComponent,
    ToolbarComponent,
  ],
  templateUrl: './prepare.component.html',
  styleUrl: './prepare.component.scss',
})
export class PrepareComponent implements OnInit {
  zoom = 0.5;
  contextData?: IContext;
  organizationChart?: IOrganizationNode;
  isLoading = true;
  scenairoId = '';
  constructor(
    readonly _prepareService: PrepareService,
    readonly _tabsService: TabsService,
    readonly router: Router,
    readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getContextData();
    this.getOrganizationChart();
  }

  async getContextData() {
    try {
      this.isLoading = true;
      this.scenairoId = this.route.snapshot.paramMap.get('id')!;
      sessionStorage.setItem('scenarioId', this.scenairoId);

      this.contextData = await this._prepareService.getContext(
        this.scenairoId!
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  async getOrganizationChart() {
    try {
      this.isLoading = true;
      const response = await this._prepareService.getOrganizationChart(
        this.scenairoId
      );
      this.organizationChart = response.organization_chart;
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  increaseZoom() {
    this.zoom = Math.min(this.zoom + 0.1, 2); // OPTIONAL: MAX ZOOM
  }

  decreaseZoom() {
    this.zoom = Math.max(this.zoom - 0.1, 0.1); // OPTIONAL: MIN ZOOM
  }

  navigateToUrl(path: string) {
    this.router.navigate([path]);
  }

  startTest() {
    this.router.navigate([`/scenario/decide/${this.scenairoId}`]);
  }

  getFormattedContextItems(): string[] {
    if (!this.contextData?.context) {
      return [];
    }

    // Split by sentences and filter out empty strings
    const sentences = this.contextData.context
      .split('.')
      .filter((sentence) => sentence.trim().length > 0);

    return sentences.map((sentence) => {
      const trimmed = sentence.trim();
      // Find the colon position
      const colonIndex = trimmed.indexOf(':');

      if (colonIndex > 0) {
        const title = trimmed.substring(0, colonIndex);
        const content = trimmed.substring(colonIndex + 1).trim();
        return `<strong>${title}:</strong> ${content}`;
      }

      return trimmed;
    });
  }

  getFormattedChallengeItems(): string[] {
    if (!this.contextData?.challenge_you_will_face) {
      return [];
    }

    // Split by sentences and filter out empty strings
    const sentences = this.contextData.challenge_you_will_face
      .split('.')
      .filter((sentence) => sentence.trim().length > 0);

    return sentences.map((sentence) => {
      const trimmed = sentence.trim();
      // Find the colon position
      const colonIndex = trimmed.indexOf(':');

      if (colonIndex > 0) {
        const title = trimmed.substring(0, colonIndex);
        const content = trimmed.substring(colonIndex + 1).trim();
        return `<strong>${title}:</strong> ${content}`;
      }

      return trimmed;
    });
  }
}
